import React, { useState } from 'react';

interface AdminLoginProps {
  onLogin: (success: boolean) => void;
}

export const AdminLogin: React.FC<AdminLoginProps> = ({ onLogin }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (password === '12345') {
      onLogin(true);
      setError('');
    } else {
      setError('Invalid password');
      setPassword('');
    }
  };

  return (
    <div className="flex justify-center pt-20">
      <div className="w-80 bg-white border border-gray-200 rounded-lg shadow-xl">
        <div className="bg-gradient-to-r from-green-600 to-green-700 text-white px-4 py-3 text-center font-medium rounded-t-lg">
          🔒 Cricket Admin Access
        </div>
        <div className="p-6">
          <form onSubmit={handleSubmit}>
            <div className="mb-8">
              <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-4">
                Enter Admin Password:
              </label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Password"
                autoFocus
              />
            </div>

            {error && (
              <div className="text-red-600 text-sm text-center mb-6">
                {error}
              </div>
            )}

            <button
              type="submit"
              className="w-full bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white py-2 px-4 rounded focus:outline-none focus:ring-2 focus:ring-green-500 shadow-md transition-all"
            >
              🏏 Access Cricket Admin
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};